import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Component } from 'react';
import classes from './LogSelector.module.css';
import { sortLogNamesForDisplay } from 'shared/utility';

class LogSelector extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // filterInput: '',
      // newTag: '',
      // newTagCategory: null,
      // showNewTagCategoryModal: false,
      // tagCreated: false,
      listHeight: this.props.shortWindow === true ? 494 : 572,
    };
    this.selectedLogs = React.createRef();
  }

  componentDidMount() {
    this.setLogsSelectorHeight();
  }

  componentDidUpdate(prevProps) {
    // resize scroll box height when selected logs changes
    if (prevProps.selectedLogs !== this.props.selectedLogs) {
      this.setLogsSelectorHeight();
    }
  }

  setLogsSelectorHeight = () => {
    const listHeight =
      this.props.shortWindow === true
        ? this.selectedLogs.current
          ? 522 - this.selectedLogs.current.clientHeight
          : 522
        : this.selectedLogs.current
        ? 600 - this.selectedLogs.current.clientHeight
        : 600;
    this.setState({ listHeight });
  };

  render = () => {
    // sort logs so that private log shows up first, followed by logs in alphabetical order
    const sortedLogs = sortLogNamesForDisplay([...this.props.logs]);

    const logList = sortedLogs.map((log, i) => (
      <div className={classes.Log} name={`log-${i}`} key={log.Id} onClick={() => this.props.handleUpdateLogControls(log.Id, log.Name)}>
        {log.Name}
        {this.props.selectedLogs.includes(log.Id) === true ? <FontAwesomeIcon icon="check" className={classes.CheckMark} /> : null}
      </div>
    ));

    const selectedLogs = sortedLogs.filter((log) => this.props.selectedLogs.includes(log.Id));

    const selectedLogTags = selectedLogs.map((selectedLog) => (
      <span key={selectedLog.Id} className={classes.Tag} onClick={() => this.props.handleUpdateLogControls(selectedLog.Id, selectedLog.Name)}>
        {selectedLog.Name}
        <FontAwesomeIcon icon="times" className={classes.UnselectLog} />
      </span>
    ));

    return (
      <div className={classes.LogSelectorContainer}>
        <div className={classes.SelectedLogs} ref={this.selectedLogs}>
          {selectedLogTags}
        </div>
        <p className={classes.SubTitle}>Select log(s) for this post</p>
        <div id="log-list-container" style={{ height: `${this.state.listHeight}px` }} className={classes.LogList}>
          {logList}
        </div>
      </div>
    );
  };
}

export default LogSelector;
